import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { PageHeader } from "@/components/common/Loader";
import { useFetch } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { GUIDE } from "@/lib/guide";
import { InstallButton } from "@/components/common/Install";

const Section = ({ g, i }) => (
  <section data-testid={`guide-section-${g.id}`} className="lux-card p-6 sm:p-8 animate-fade-up" style={{ animationDelay: `${80 + i * 70}ms` }}>
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-center gap-4">
        <span className="w-12 h-12 shrink-0 rounded-full border border-gold/30 bg-gold/[0.08] flex items-center justify-center"><g.icon className="w-5 h-5 text-gold" strokeWidth={1.4} /></span>
        <div><h2 className="text-2xl sm:text-3xl font-normal">{g.title}</h2><p className="text-sm text-warm-text mt-1">{g.intro}</p></div>
      </div>
    </div>
    <ul className="mt-6 space-y-3">
      {g.can.map((c) => (
        <li key={c} className="flex gap-3 text-sm leading-relaxed"><span className="mt-2 w-1.5 h-1.5 shrink-0 rounded-full bg-gold" />{c}</li>
      ))}
    </ul>
    {g.external
      ? <a href={g.path} target="_blank" rel="noopener noreferrer" data-testid={`guide-open-${g.id}`} className="btn-ghost mt-6">Apri {g.title} <ArrowUpRight className="w-4 h-4" /></a>
      : <Link to={g.path} data-testid={`guide-open-${g.id}`} className="btn-ghost mt-6">Apri {g.title} <ArrowUpRight className="w-4 h-4" /></Link>}
  </section>
);

function NewsHistory() {
  const { data } = useFetch("/news");
  if (!data?.length) return null;
  return (
    <section className="mt-14">
      <p className="eyebrow mb-5">Tutte le novità</p>
      <div className="space-y-3">
        {data.map((n) => (
          <div key={n.id} data-testid={`guide-news-${n.id}`} className="lux-card p-5 sm:p-6">
            <div className="flex items-center gap-3"><Sparkles className="w-4 h-4 text-gold" /><p className="font-serif text-xl">{n.title}</p></div>
            <p className="text-sm text-warm-text mt-2 whitespace-pre-wrap leading-relaxed">{n.body}</p>
            <p className="text-[11px] uppercase tracking-[0.16em] text-warm-text mt-3">{fmtDate(n.created_at)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function Guide() {
  return (
    <div>
      <PageHeader eyebrow="Guida" title="Come usare l'app" subtitle="Tutto quello che puoi fare in ogni sezione di My Skin Lovers." actions={<InstallButton testid="guide-install-btn" />} />
      <div className="grid gap-4 sm:gap-5">{GUIDE.map((g, i) => <Section key={g.id} g={g} i={i} />)}</div>
      <NewsHistory />
    </div>
  );
}
